import { IndexRoute, Route } from 'react-router'

import { getCalendar } from 'app/modules/meetings/selectors'

import ManageCalendarBeta from 'components/settings/meetings'
import CalendarConnect from 'components/settings/meetings/CalendarConnect'
import CalendarAdvanced from 'components/settings/meetings/CalendarAdvanced'
import MeetingTypeEdit from 'components/settings/meetings/MeetingTypeEdit'

export const Routes = store => (
  <Route path="/settings/calendar">
    <IndexRoute key="index" component={ManageCalendarBeta} />
    <Route path="advanced" component={CalendarAdvanced} />
    <Route path="connect" component={CalendarConnect} />
    <Route path="edit/:meetingTypeSlug" component={MeetingTypeEdit} />
  </Route>
)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/meetings/routes.js